<div class="label-picker" ng-click="$ctrl.toggleLabelList()">
    <div class="selected">
        <c-label-item ng-repeat="label in $ctrl.selectedLabels() track by $index" item="label"></c-label-item>
    </div>
    <i class="menu-angle fa fa-angle-down"></i>
</div>
<div ng-if="$ctrl.showLabelList" class="select-menu-container">
    <ul class="label-list">
        <li ng-repeat="label in $ctrl.selectedLabels() track by $index" class="selected-label">
            <span class="check">✔</span><i class="blob fa fa-circle" ng-style="$ctrl.labelStyle(label)"></i><span class="name">{{label.Name|translate}}</span><span class="times" ng-click="$ctrl.removeLabel(label)">×</span>
            <span class="comment">{{label.Description|translate}}</span>
        </li>
        <li ng-repeat="label in $ctrl.notSelectedLabels() track by $index" class="not-selected-label" ng-click="$ctrl.addLabel(label)">
            <span class="check">✔</span><i class="blob fa fa-circle" ng-style="$ctrl.labelStyle(label)"></i><span class="name">{{label.Name|translate}}</span>
            <span class="comment">{{label.Description|translate}}</span>
        </li>
    </ul>
</div>